import humps from "humps";

import { getRailsClient } from "../client";

// Helper to convert camelCase to snake_case with proper number handling
const toSnakeCase = (str: string): string => {
  return humps
    .decamelize(str)
    .replace(/([a-z])(\d)/gi, "$1_$2") // Add underscore before numbers
    .replace(/(\d)([a-z])/gi, "$1_$2"); // Add underscore after numbers
};

export interface LeaderboardParams {
  page?: number;
  query?: string;
  recordsPerPage?: number;
  direction?: string;
  sortBy?: string;
}

export interface LeaderboardResponse {
  users: LeaderboardUser[];
  page: number;
  pagesNumber: number;
}

export interface LeaderboardUser {
  active: boolean;
  currentBelt: string;
  currentBeltImage: any;
  gravatarId: string;
  lastActive: string;
  name: string;
  passedRoleImageUrl: any;
  ranking: number;
  rating: number;
  thumbImageUrl: string;
  totalPoints: number;
  pointsPast30Days: number;
  weeklyStreak: number;
  company: any;
  jobRole: any;
  country: any;
}

// Fetches leaderboard data with pagination, search, and sorting
export const getLeaderboard = async ({
  page = 1,
  query = "",
  recordsPerPage = 10,
  direction,
  sortBy = "",
}: LeaderboardParams = {}): Promise<LeaderboardResponse> => {
  const API = `/api/internal_api/v1/leaderboard`;

  try {
    const params: any = {
      page,
      per_page: recordsPerPage,
    };

    if (query) {
      params.query = query;
    }

    if (direction) {
      params.direction = direction;
    }

    if (sortBy) {
      params.sort_by = toSnakeCase(sortBy);
    }

    const { data } = await getRailsClient().get(API, { params });

    return {
      users: data.users || [],
      page: data.page || page,
      pagesNumber: data.pagesNumber || 1,
    };
  } catch (error) {
    console.error("Error fetching leaderboard:", error);
    throw error;
  }
};
